// file: src/components/questions/QuestionForm.js
import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { createQuestion, updateQuestion } from "../../services/questionService";

const QuestionForm = ({ question, questions = [], onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    parent_id: "",
    description: "",
    weight: 1,
    has_child: 0,
    child_format: "radio",
    path_index: "",
    parent_path_index: "",
  });

  useEffect(() => {
  if (question) {
   let parentPath = question.parent_path_index || "";
  if (!parentPath && question.parent_id) {
     const parentQ = questions.find((q) => q.id === question.parent_id);
     parentPath = parentQ ? parentQ.path_index : "";
 }
   setFormData({
     parent_id: question.parent_id || "",
     description: question.description || "",
     weight: question.weight || 1,
     has_child: question.has_child || 0,
     child_format: question.child_format || "radio",
     path_index: question.path_index || "",
     parent_path_index: parentPath,
   });
  }
}, [question, questions]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox" ? (checked ? 1 : 0) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (question) {
        await updateQuestion(question.id, formData);
        toast.success("Pertanyaan berhasil diperbarui");
      } else {
        await createQuestion(formData);
        toast.success("Pertanyaan baru berhasil ditambahkan");
      }
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error("Gagal menyimpan data pertanyaan");
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Parent Path</Form.Label>
            <Form.Control
              type="text"
              value={formData.parent_path_index || "(Root)"}
              disabled
            />
          </Form.Group>
        </Col>
        <Col md={6}>
        {/* Path Index otomatis */}
          <p className="text-muted">Path Index akan dibuat otomatis.</p>
          {/*
          <Form.Group className="mb-3">
            <Form.Label>Path Index</Form.Label>
            <Form.Control
              type="text"
              name="path_index"
              value={formData.path_index}
              onChange={handleChange}
              placeholder="Misal: 1.1 atau 2.3.1"
            />
          </Form.Group>
          */}
        </Col>
      </Row>

      <Form.Group className="mb-3">
        <Form.Label>Deskripsi</Form.Label>
        <Form.Control
          type="text"
          name="description"
          value={formData.description}
          onChange={handleChange}
          required
        />
      </Form.Group>

      <Row>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Weight</Form.Label>
            <Form.Control
              type="number"
              name="weight"
              value={formData.weight}
              onChange={handleChange}
              step="0.01"
              min="0"
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              label="Has Child"
              name="has_child"
              checked={formData.has_child === 1}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Child Format</Form.Label>
            <Form.Select
              name="child_format"
              value={formData.child_format}
              onChange={handleChange}
            >
              <option value="radio">Radio</option>
              <option value="checkbox">Checkbox</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={onCancel}>
          Batal
        </Button>
        <Button variant="primary" type="submit">
          {question ? "Update" : "Simpan"}
        </Button>
      </div>
    </Form>
  );
};

export default QuestionForm;
